export default {
  creditUsage: {
    pageTitle: "Credit Reporting",
    date: "Date",
    time: "Time",
    id: "ID",
    listingType: "Listing Type",
    activity: "Activity",
    creditType: "Credit Type",
    credit: "Credit",
    filter: {
      label: "Filters",
      buttonLabel: "Filter",
      notFound: {
        heading:
          "We couldn't find any credit usage history that match your refinements.",
        subHeading:
          "Try changing your criteria to find the property you are after.",
      },
      creditType: {
        title: "Credit type",
      },
      activityGroup: {
        title: "Activities",
      },
      listingId: {
        title: "Listing ID",
        placeholder: "Search by listing ID",
      },
      dateFrom: {
        title: "Start Date",
      },
      dateTo: {
        title: "End Date",
      },
    },
    back: "Back",
    returnTop: "Return to the top of the result",
    viewUniversalCreditsReporting: "View Universal Credits Reporting",
  },
};
